module.exports = "https://cdn.realtymogul.com/static/media/img_advantage.7899f05e.jpg";